var map = {
	"./aquatic/background_1.png": 649,
	"./aquatic/base_1.png": 650,
	"./aquatic/decoa_1.png": 651,
	"./aquatic/mainbuilding_1.png": 652,
	"./aquatic/pet_1.png": 653,
	"./aquatic/subbuildinga_1.png": 654,
	"./aquatic/subbuildingb_1.png": 655,
	"./glacial/background_1.png": 656,
	"./glacial/base_1.png": 657,
	"./glacial/decoa_1.png": 658,
	"./glacial/mainbuilding_1.png": 659,
	"./glacial/pet_1.png": 660,
	"./glacial/subbuildinga_1.png": 661,
	"./glacial/subbuildingb_1.png": 662,
	"./golem/background_1.png": 663,
	"./golem/base_1.png": 664,
	"./golem/decoa_1.png": 665,
	"./golem/mainbuilding_1.png": 666,
	"./golem/pet_1.png": 667,
	"./golem/subbuildinga_1.png": 668,
	"./golem/subbuildingb_1.png": 669,
	"./inferno/background_1.png": 670,
	"./inferno/base_1.png": 671,
	"./inferno/decoa_1.png": 672,
	"./inferno/mainbuilding_1.png": 673,
	"./inferno/pet_1.png": 674,
	"./inferno/subbuildinga_1.png": 675,
	"./inferno/subbuildingb_1.png": 676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2155;